module.exports = __webpack_public_path__ + "img/sdostavkoj-mob.569b2119.png";